module.exports = __webpack_public_path__ + "static/TULSA-PRO-vs-HIFU-blog-post-01-7567ee20bb3ce3ee89fdd212a4a5915c.png";